export const SUPPORT_PHONE_NUMBER = '(11) 2551-1899'

export const SUPPORT_WHATSAPP_PHONE_NUMBER = '(11) 2151-3410'
export const SUPPORT_WHATSAPP_PHONE_LINK = 'https://wa.me/551121513410'

export const SUPPORT_EMAIL_ADDRESS = 'suportetm.corpoclinico@einstein.br'
export const SUPPORT_EMAIL_ADDRESS_LINK = 'mailto:suportetm.corpoclinico@einstein.br'
